import type { TrendItem } from "app/pages/sales-intelligence/common-components/table-cells";
import type { AppOperatingSystem } from "app/pages/sales-intelligence/domain/apps/types/platform";

export const digitalAssetTypeMap = {
    websites: "websites",
    apps: "apps",
} as const;
export type DigitalAssetType = keyof typeof digitalAssetTypeMap;

export type AppsDigitalAsset = {
    readonly icon: string;
    readonly market: AppOperatingSystem;
    readonly appId: string;
};

export type WebsitesDigitalAsset = {
    readonly icon: string;
    readonly domain: string;
};

export type DigitalAssetsList<T = WebsitesDigitalAsset | AppsDigitalAsset> = {
    readonly items: ReadonlyArray<T>;
    readonly total: number;
};

export type DigitalAssetsSummaryResponseDto = {
    readonly websites: DigitalAssetsList<WebsitesDigitalAsset>;
    readonly apps: DigitalAssetsList<AppsDigitalAsset>;
};

export type AppsDigitalAssetRecord = AppsDigitalAsset & {
    readonly appName: string;
    readonly monthlyActiveUsers: number;
    readonly monthlyDownloads: number;
    readonly developerName: string;
};

export type WebsitesDigitalAssetRecord = WebsitesDigitalAsset & {
    readonly monthlyVisitsChangeMom: number;
    readonly visits: number;
    readonly topGeoCountry: number;
    readonly visitsHistory: readonly TrendItem[];
};

export type DigitalAssetsRecordsMap = {
    readonly websites: WebsitesDigitalAssetRecord;
    readonly apps: AppsDigitalAssetRecord;
};

export type DigitalAssetsRecordsResponseDto<T extends DigitalAssetType> = DigitalAssetsRecordsMap[T][];
